import React from 'react';
export function Footer() {
  return <footer className="bg-gray-100 py-8" data-id="element-21">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-gray-600" data-id="element-22">
        <p className="mb-2" data-id="element-23">© 2023 Neurotoned. All rights reserved.</p>
        <div className="flex justify-center space-x-4" data-id="element-24">
          <a href="https://www.neurotoned.com/privacy-policy" className="hover:text-teal-600" data-id="element-25">
            Privacy Policy
          </a>
          <a href="https://www.neurotoned.com/terms-and-conditions" className="hover:text-teal-600" data-id="element-26">
            Terms of Service
          </a>
          <a href="https://www.neurotoned.com/contact-us" className="hover:text-teal-600" data-id="element-27">
            Contact Us
          </a>
        </div>
      </div>
    </footer>;
}